var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { proxyApi } from "./index";
import { config } from '../config/constants';
import { request } from './request';
/** 视频校验类型 */
export var VideoAccessType;
(function (VideoAccessType) {
    /** 立即校验 */
    VideoAccessType["Immediate"] = "0";
    /** 试看后校验 */
    VideoAccessType["AfterPreivew"] = "1";
})(VideoAccessType || (VideoAccessType = {}));
export var DocumentAccess;
(function (DocumentAccess) {
    DocumentAccess["Immediate"] = "0";
    DocumentAccess["ClickDownload"] = "1";
    DocumentAccess["PreviewEnd"] = "2";
})(DocumentAccess || (DocumentAccess = {}));
/**
 * 资源管理 的代理接口
 * @description 系统资源管理模块的暴露接口
 * @export
 * @param {string} target 请求路由
 * @param {*} [data] 请求参数
 */
export function resourceApi(target, data, freeLogin) {
    return proxyApi({ module: 'resource', target, data, freeLogin });
}
/**
 * 获取视频资源config
 */
export function getVideoConfig(hashId = config.uaId) {
    return resourceApi('videoDetail', {
        hashId
    }, 1);
}
/**
 * 获取文档资源config
 */
export function getDocumentConfig(hashId = config.uaId) {
    return resourceApi('documentDetail', {
        hashId
    }, 1);
}
/**
 * 查询视频观看进度
 */
export function getVideoProgress(hashId = config.uaId) {
    return resourceApi('getVideoProgress', {
        hashId,
    });
}
/**
 * 保存视频观看进度
 */
export function saveVideoProgress(progress, hashId = config.uaId) {
    return resourceApi('saveVideoProgress', {
        hashId,
        progress
    });
}
/**
 * 批量查询视频观看次数
 */
export function getResourceAnalytics(ids, type) {
    return resourceApi('analytics', {
        ids,
        type
    });
}
/** 指定文档发送到指定邮箱 */
export function sendDoc2Mail(resourceIds, email, freeLogin = 1) {
    return __awaiter(this, void 0, void 0, function* () {
        return resourceApi('documentSendToMail', {
            resourceIds,
            email,
            path: window.location.href
        }, freeLogin);
    });
}
/**
 * 图片上传
 * @description 调用获取参数后，使用直传接口上传资源
 */
export const upload2Oss = (signature, file) => {
    const formData = new FormData();
    for (const [k, v] of Object.entries(signature)) {
        formData.append(k, v);
    }
    formData.append('file', file);
    return request.post(signature.requestUri, formData);
};
/**
 * @deprecated 使用cms存储数据
 * 获取指定json
 */
export function getJson(file) {
    return request.get(file, {
        headers: {
            'Cache-Control': 'no-cache',
        },
    });
}
/**
 * 获取资源授权后的签名地址
 */
export function getSignatureUrl(file) {
    return __awaiter(this, void 0, void 0, function* () {
        let url;
        if (/download\.(cloud|beta)\.custouch\.com/.test(file)) {
            url = (yield request.get(file, { params: { view: 2 } }));
        }
        else {
            url = file;
        }
        return url;
    });
}
/**
 * 获取资源上传信息
 * @param {('video' | 'document')} type
 * @param {string} ids
 */
export function getResourceDetail(type, ids) {
    return __awaiter(this, void 0, void 0, function* () {
        return (yield resourceApi('uploadInfo', {
            ids,
            type
        })).ret;
    });
}
